import type { FC } from 'react'
import styled from '@emotion/styled'

import ColumnTrack from '@segment/matcha/components/ColumnTrack'
import FeatureBoxBase, * as FeatureBox from '@segment/matcha/components/FeatureBox'
import { ChevronRightIcon } from '@segment/matcha/components/Icons/Common'
import ButtonText from '@segment/matcha/components/ButtonText'

import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'
import SectionBase, * as Section from '@segment/matcha/recipes/Section'

const StyledSectionBase = styled(SectionBase)`
  max-width: 1280px;

  ${({ theme }) => theme.breakpoints.up(`xl`)} {
    margin-top: 100px;
  }
`

const StyledFeatureBoxBase = styled(FeatureBoxBase)`
  padding: 0 16px;
  max-width: 302px;
  justify-self: center;

  ${({ theme }) => theme.breakpoints.up(`md`)} {
    padding: 0 20px;
    max-width: unset;
  }
`

const StyleHeading = styled(CopyText.Heading)`
  max-width: 680px;
`

const ButtonWrapper = styled.div`
  display: flex;
  margin-top: 56px;
  justify-content: center;
`

const copy = {
  heading: `Get more out of Facebook with Segment`,
}

const boxes = [
  {
    title: `Streamline instrumentation`,
    text: `By simplifying the instrumentation of Facebook’s Pixel, App Events, Offline Conversions, Lead Ads, and Custom Audiences, as well as your other digital marketing tools, Segment unlocks developer and marketing resources to focus on other tasks.`,
  },
  {
    title: `Identify the right audience`,
    text: `Send targeted messages by leveraging Twilio Engage. Merge a user’s identity across different channels into a single profile and create Audiences, like Big Spenders, that can be directly connected in Facebook using Custom Audiences.`,
  },
  {
    title: `Understand campaign impact`,
    text: `Combine your Facebook Ad campaign data alongside the data from your other customer touchpoints and load it directly in your data warehouse, so you can better understand how your ads influenced conversions and the events that lead up to them.`,
  },
]

export const GetMore: FC = () => {
  return (
    <StyledSectionBase variant="centered">
      <Section.Copy>
        <CopyTextBase centered={true}>
          <StyleHeading tag="h2">{copy.heading}</StyleHeading>
        </CopyTextBase>
      </Section.Copy>
      <Section.Contents>
        <ColumnTrack columns={1} overrides={{ md: 3 }}>
          {boxes.map(({ title, text }, i) => (
            <StyledFeatureBoxBase key={i} alignment="left">
              <FeatureBox.Body>
                <FeatureBox.Title>{title}</FeatureBox.Title>
                <FeatureBox.Text>{text}</FeatureBox.Text>
              </FeatureBox.Body>
            </StyledFeatureBoxBase>
          ))}
        </ColumnTrack>
        <ButtonWrapper>
          <ButtonText
            tag="a"
            size="medium"
            href={`https://segment.com/docs/connections/sources/catalog/cloud-apps/facebook-ads/`}
            iconEnd={ChevronRightIcon}
          >
            Learn more
          </ButtonText>
        </ButtonWrapper>
      </Section.Contents>
    </StyledSectionBase>
  )
}

export default GetMore
